import React from 'react'

const AddGuestIcon = ({ style, onClickCb = () => { } }) => {
    return (
        <svg style={style} onClick={onClickCb} id="Component_2279_8" data-name="Component 2279 – 8" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g id="Group_93495" data-name="Group 93495" transform="translate(-10180 4581)">
                <g id="Group_93494" data-name="Group 93494">
                    <g id="Ellipse_1315" data-name="Ellipse 1315" transform="translate(10180 -4581)" fill="#fff" stroke="#aaa" strokeWidth="1" opacity="0">
                        <circle cx="20" cy="20" r="20" stroke="none" />
                        <circle cx="20" cy="20" r="19.5" fill="none" />
                    </g>
                    <g id="person_add_black_24dp" transform="translate(10188 -4573)">
                        <path id="Path_206776" data-name="Path 206776" d="M0,0H24V24H0Z" fill="none" />
                        <path id="Path_206777" data-name="Path 206777" d="M15,12a4,4,0,1,0-4-4A4,4,0,0,0,15,12Zm0-6a2,2,0,1,1-2,2A2.006,2.006,0,0,1,15,6Zm0,8c-2.67,0-8,1.34-8,4v2H23V18C23,15.34,17.67,14,15,14ZM9,18c.22-.72,3.31-2,6-2s5.8,1.29,6,2ZM6,15V12H9V10H6V7H4v3H1v2H4v3Z" fill="#fff" />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default AddGuestIcon
